import { isDebuggerEnable, isDebuggerGrouped } from '@b2x/std/core/debug.mjs';
import { isLocalhost } from '@b2x/std/core/utilities.mjs';
import { consola } from '@b2x/std/logger/consola.mjs';
import { BrowserReporter } from '@b2x/std/logger/reporters/browser.mjs';

const LOGGER_NAMESPACE = 'B2X@LAL';

function initializeLogger() {
  consola.setLogger(LOGGER_NAMESPACE, {
    reporters: [
      new BrowserReporter({
        title: `LAL@${VERSION}-${BUILD_TIME}`,
        namespace: LOGGER_NAMESPACE,
        delay: 1500,
        grouped: isDebuggerGrouped(LOGGER_NAMESPACE),
        enabled: isDebuggerEnable(LOGGER_NAMESPACE) || isLocalhost(),
      }),
    ],
  });

  return {
    createLogger: (group: string) => consola.createLoggerGroup(LOGGER_NAMESPACE, group),
  };
}

export const logger = initializeLogger();
